import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { baseURLFinanceVendor } from "config/apiConfig";
import { getStoredArray } from "utils/imageUtils";

const ClaimsContext = createContext(null);
const getTodayDate = () => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  return date;
};

const getPreviousMonthDate = () => {
  const today = new Date();
  const previousMonth = new Date(today);

  previousMonth.setMonth(previousMonth.getMonth() - 1);
  previousMonth.setHours(0, 0, 0, 0);

  return previousMonth;
};


export const ClaimsProvider = ({ children }) => {
  const startDateInitial = getPreviousMonthDate();
  const endDateInitial = new Date();

  const [claims, setClaims] = useState([]);
  const [totalClaimsCount, setTotalClaimsCount] = useState(0);
  const [loadingClaims, setLoadingClaims] = useState(false);
  const [error, setError] = useState(null);

  const fetchClaims = async (startDate = null, endDate = null) => {
    try {
      setLoadingClaims(true);

      const payload = {
        dealerName: getStoredArray("dealer")?.join(",") || null,
        vendorName: getStoredArray("vendor")?.join(",") || null,
        caseStatus: null,

        fromDate: startDate || null,
        toDate: endDate || null,
      };

      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${baseURLFinanceVendor}GetCustomerDetailsReport_New`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res?.data?.status) {
        const exactCount = res?.data?.data.length;

        setClaims(res?.data?.data ?? []);
        setTotalClaimsCount(exactCount);
      }
    } catch (err) {
      console.error("Claims fetch failed:", err);
      setError("Failed to load claims");
    } finally {
      setLoadingClaims(false);
    }
  };

  useEffect(() => {
    fetchClaims(startDateInitial, endDateInitial);
  }, []);


  return (
    <ClaimsContext.Provider
      value={{
        claims,
        totalClaimsCount,
        loadingClaims,
        error,
        fetchClaims,
      }}
    >
      {children}
    </ClaimsContext.Provider>
  );
};


export const useClaims = () => {
  const context = useContext(ClaimsContext);

  if (!context) {
    throw new Error("useClaims must be used inside ClaimsProvider");
  }

  return context;
};